import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { firebaseConnect } from 'react-redux-firebase';
import { ModalView, ListSection, Input, Select } from 'medua-components';

/* eslint-disable */
@firebaseConnect()
@translate(['courses', 'terms', 'degree', 'languages'])
export default class ModalAddCourse extends Component {

  constructor(props) {
    super(props)
    this.state = {
      school: {
        key: props.school.key,
        name: props.school.name
      }
    }

    this.formItem = this.formItem.bind(this)
    this.handleAdd = this.handleAdd.bind(this)
  }

  formItem(item, attr, value) {
    let i = {}
    if (this.state[item]) {
      i = this.state[item]
    }
    if (item == 'degree' && attr == 'type') {
      i.title = null
    }
    i[attr] = value
    this.setState({ [item]: i })
  }

  handleAdd() {
    let object = {}
    if (this.state.name && this.state.name.length < 4) {
      this.setState({ error: this.props.t('courses:modals.error.course-name') });
      return
    } else {
      object.name = this.state.name
    }
    // school
    if (!this.state.school) {
      this.setState({ error: 'Invalid school, contact support (#3001)' });
      return
    } else {
      if (!this.state.school.key || !this.state.school.name) {
        this.setState({ error: 'Invalid school, contact support (#3001)' });
        return
      }
      object.school = this.state.school
    }
    // degree
    if (!this.state.degree) {
      this.setState({ error: 'Degree'});
      return
    } else {
      if (!this.state.degree.type) {
        this.setState({ error: 'Degree Type'});
        return
      } else {
        if (!this.state.degree.title) {
          object.degree = {
            type: this.state.degree.type
          }
        } else {
          object.degree = {
            type: this.state.degree.type,
            title: this.state.degree.title
          }
        }
      }
    }
    // duration
    if (!this.state.duration) {
      this.setState({ error: 'Duration'});
      return
    } else {
      if (!this.state.duration.start || this.state.duration.start.length < 1) {
        this.setState({ error: 'Duration Start'});
        return
      }
      if (this.state.duration.amount == undefined) {
        this.setState({ error: 'Duration Amount'});
        return
      }
      if (!this.state.duration.interval) {
        this.setState({ error: 'Duration Interval'});
        return
      }
      if (!this.state.duration.type) {
        this.setState({ error: 'Duration Type'});
        return
      }
      object.duration = this.state.duration
    }
    // credits
    if (!this.state.credits) {
      this.setState({ error: 'Credits'});
      return
    } else {
      if (this.state.credits.amount == undefined) {
        this.setState({ error: 'Credits Amount'});
        return
      }
      if (this.state.credits.amount != '0' && !this.state.credits.type) {
        this.setState({ error: 'Credits Type'});
        return
      }
      if (this.state.credits.amount == '0') {
        object.credits = {
          amount: 0,
          type: 'none'
        }
      } else {
        object.credits = {
          amount: this.state.credits.amount,
          type: this.state.credits.type
        }
      }
    }
    // costs
    if (!this.state.costs) {
      this.setState({ error: 'Costs'});
      return
    } else {
      if (this.state.costs.amount == undefined) {
        this.setState({ error: 'Costs Amount'});
        return
      }
      if (this.state.costs.amount != '0' && !this.state.costs.currency) {
        this.setState({ error: 'Costs Currency'});
        return
      }
      if (this.state.costs.amount != '0' && !this.state.costs.interval) {
        this.setState({ error: 'Costs Interval'});
        return
      }
      if (this.state.costs.amount == '0') {
        object.costs = {
          amount: 0,
          currency: 'eur',
          interval: 100
        }
      } else {
        object.costs = {
          amount: this.state.costs.amount,
          currency: this.state.costs.currency,
          interval: this.state.costs.interval
        }
      }
    }
    // requirements
    if (Object.keys(this.state.requirements).length !== 0 && this.state.requirements.constructor === Object) {
      let requirements = {}
      if (this.state.requirements.numerus_clausus) {
        requirements.numerus_clausus = this.state.requirements.numerus_clausus
      }
      if (this.state.requirements.degree) {
        requirements.degree = this.state.requirements.degree
      }
      if (this.state.requirements.credits != undefined) {
        requirements.credits = this.state.requirements.credits
      }
      object.requirements = requirements
    }
    // additions
    if (Object.keys(this.state.additions).length !== 0 && this.state.additions.constructor === Object) {
      if (this.state.additions.languages) {
        object.languages = this.state.additions.languages
      }
      if (this.state.additions.numerus_clausus) {
        object.numerus_clausus = this.state.additions.numerus_clausus
      }
      if (this.state.additions.url) {
        object.url = this.state.additions.url
      }
    }

    console.log(object);

    this.props.firebase.push(
      'course', object
    ).then((course) => {
      this.props.closeModal();
    })
  }

  render() {
    if (this.state.success) {
      return (
        <Modal success
          title="Successfully created!" />
      )
    }
    return (
      <ModalView
        title={ this.props.t('courses:modals.add') }
        color="dark"
        actionLeft={[
          { key: 1, icon: 'cancel', action: this.props.closeModal }
        ]}
        actionRight={[
          { key: 1, icon: 'save', action: this.handleAdd }
        ]}
        error={ this.state.error }>
        <ListSection
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Input
            meta={ this.props.t('terms:course-name') }
            placeholder={ this.props.t('courses:modals.placeholder.course-name') }
            onChange={ (e) => this.setState({ name: e.target.value }) } />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:degree') }
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Select half
            meta={ this.props.t('terms:degree-type') }
            options={[
              { value: 'bachelor', label: this.props.t('degree:type.bachelor') },
              { value: 'master', label: this.props.t('degree:type.master') },
              { value: 'stateexamination', label: this.props.t('degree:type.stateexamination') },
              { value: 'diploma', label: this.props.t('degree:type.diploma') },
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.degree-type') }
            onChange={ (e) => this.formItem('degree', 'type', e.value) }
            />
          <Select half
            required
            meta={ this.props.t('terms:degree-title') }
            options={
              this.state.degree && this.state.degree.type == 'bachelor' ?
              [
                { value: 'ba', label: this.props.t('degree:title.ba') },
                { value: 'bed', label: this.props.t('degree:title.bed') },
                { value: 'beng', label: this.props.t('degree:title.beng') },
                { value: 'bfa', label: this.props.t('degree:title.bfa') },
                { value: 'llb', label: this.props.t('degree:title.llb') },
                { value: 'bmus', label: this.props.t('degree:title.bmus') },
                { value: 'bsc', label: this.props.t('degree:title.bsc') },
              ]
              : this.state.degree && this.state.degree.type == 'master' ?
                [
                  { value: 'ma', label: this.props.t('degree:title.ma') },
                  { value: 'mba', label: this.props.t('degree:title.mba') },
                  { value: 'med', label: this.props.t('degree:title.med') },
                  { value: 'meng', label: this.props.t('degree:title.meng') },
                  { value: 'llm', label: this.props.t('degree:title.llm') },
                  { value: 'mmus', label: this.props.t('degree:title.mmus') },
                  { value: 'msc', label: this.props.t('degree:title.msc') },
                ]
                : []
            }
            placeholder={ this.props.t('courses:modals.placeholder.degree-title') }
            onChange={ (e) => this.formItem('degree', 'title', e.value )} />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:duration') }
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Input half
            type="number"
            meta={ this.props.t('terms:duration-amount') }
            placeholder={ this.props.t('courses:modals.placeholder.duration-amount') }
            onChange={ (e) => this.formItem('duration', 'amount', parseInt(e.target.value)) } />
          <Select half
            meta={ this.props.t('terms:duration-interval') }
            options={[
              { value: 6, label: this.props.t('duration:interval.6') },
              { value: 3, label: this.props.t('duration:interval.3') },
              { value: 12, label: this.props.t('duration:interval.12') },
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.duration-interval') }
            onChange={ (e) => this.formItem('duration', 'interval', e.value) }
            />
          <Select half multi
            meta={ this.props.t('terms:duration-start') }
            options={
              this.state.duration && this.state.duration.interval == '3' ?
              [
                { value: '0', label: this.props.t('duration:start.0') },
                { value: '3', label: this.props.t('duration:start.3') },
                { value: '6', label: this.props.t('duration:start.6') },
                { value: '9', label: this.props.t('duration:start.9') },
              ]
              :
              [
                { value: '4', label: this.props.t('duration:start.4') },
                { value: '10', label: this.props.t('duration:start.10') },
              ]
            }
            placeholder={ this.props.t('courses:modals.placeholder.duration-start') }
            onChange={ (e) => this.formItem('duration', 'start', e) }
            />
          <Select half
            meta={ this.props.t('terms:duration-type') }
            options={[
              { value: 'full-time', label: this.props.t('duration:type.full-time') },
              { value: 'part-time', label: this.props.t('duration:type.part-time') },
              { value: 'dual', label: this.props.t('duration:type.dual') },
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.duration-type') }
            onChange={ (e) => this.formItem('duration', 'type', e.value) }
            />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:credits') }
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Input half
            type="number"
            meta={ this.props.t('terms:credits-amount') }
            placeholder={ this.props.t('courses:modals.placeholder.credits-amount') }
            onChange={ (e) => this.formItem('credits', 'amount', parseInt(e.target.value)) } />
          <Select half
            meta={ this.props.t('terms:credits-type') }
            options={[
              { value: 'ects', label: 'ECTS' },
              { value: 'cats', label: 'CATS' },
              { value: 'gpa', label: 'GPA' },
              { value: 'sch', label: 'SCH' },
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.credits-type') }
            onChange={ (e) => this.formItem('credits', 'type', e.value) }
            />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:costs') }
          accent={{ title: 'turquoise', highlight: 'turquoise'}}>
          <Input half
            type="number"
            meta={ this.props.t('terms:costs-amount') }
            placeholder={ this.props.t('courses:modals.placeholder.costs-amount') }
            onChange={ (e) => this.formItem('costs', 'amount', parseInt(e.target.value)) } />
          <Select half
            meta={ this.props.t('terms:currency') }
            options={[
              { value: 'usd', label: '$' },
              { value: 'eur', label: '€' }
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.costs-currency') }
            onChange={ (e) => this.formItem('costs', 'currency', e.value) }
            />
          <Select
            meta={ this.props.t('terms:costs-interval') }
            options={[
              { value: 100, label: this.props.t('courses:modals.costs.interval.100') },
              { value: 12, label: this.props.t('courses:modals.costs.interval.12') },
              { value: 6, label: this.props.t('courses:modals.costs.interval.6') },
              { value: 3, label: this.props.t('courses:modals.costs.interval.3') },
              { value: 1, label: this.props.t('courses:modals.costs.interval.1') },
              { value: 101, label: this.props.t('courses:modals.costs.interval.101') }
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.costs-interval') }
            onChange={ (e) => this.formItem('costs', 'interval', e.value) }
            />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:requirements') }
          accent={{ highlight: 'turquoise'}}>
          <Input half
            meta={ this.props.t('terms:numerus_clausus') }
            placeholder={ this.props.t('courses:modals.placeholder.numerus_clausus') }
            onChange={ (e) => this.formItem('requirements', 'numerus_clausus', e.target.value) } />
          <Select half multi
            meta={ this.props.t('terms:degree') }
            options={[
              { value: 'bachelor', label: this.props.t('degree:type.bachelor') },
              { value: 'master', label: this.props.t('degree:type.master') },
              { value: 'stateexamination', label: this.props.t('degree:type.stateexamination') },
              { value: 'diploma', label: this.props.t('degree:type.diploma') },
              { value: 'abitur', label: this.props.t('degree:type.abitur') },
              { value: 'fachabitur', label: this.props.t('degree:type.fachabitur') },
              { value: 'training', label: this.props.t('degree:type.training') }
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.degree-type') }
            onChange={ (e) => this.formItem('requirements', 'degree', e) }
            />
          <Input half
            type="number"
            meta={ this.props.t('terms:credits') }
            placeholder={ this.props.t('courses:modals.placeholder.credits-amount') }
            onChange={ (e) => this.formItem('requirements', 'credits', e.target.value) } />
        </ListSection>
        <ListSection
          title={ this.props.t('terms:additions') }
          accent={{ highlight: 'turquoise'}}>
          <Select half multi
            meta={ this.props.t('terms:languages') }
            options={[
              { value: 'de', label: this.props.t('languages:de') },
              { value: 'en', label: this.props.t('languages:en') },
              { value: 'nl', label: this.props.t('languages:nl') },
              { value: 'fr', label: this.props.t('languages:fr') },
              { value: 'es', label: this.props.t('languages:es') },
              { value: 'da', label: this.props.t('languages:da') },
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.languages') }
            onChange={ (e) => this.formItem('additions', 'languages', e) }
            />
          <Select half
            meta={ this.props.t('terms:channel') }
            options={[
              { value: 'online', label: this.props.t('courses:modals.channel.online') },
              { value: 'offline', label: this.props.t('courses:modals.channel.offline') },
              { value: 'both', label: this.props.t('courses:modals.channel.both') }
            ]}
            placeholder={ this.props.t('courses:modals.placeholder.channel') }
            onChange={ (e) => {
              if (e.value == 'both') {
                this.formItem('additions', 'online', true)
                this.formItem('additions', 'offline', true)
              } else if (e.value == 'online') {
                this.formItem('additions', 'online', true)
                this.formItem('additions', 'offline', false)
              } else if (e.value == 'offline') {
                this.formItem('additions', 'online', false)
                this.formItem('additions', 'offline', true)
              }
            }}
            />
          <Input
            meta={ this.props.t('terms:url') }
            placeholder={ this.props.t('courses:modals.placeholder.url') }
            onChange={ (e) => this.formItem('additions', 'url', e.target.value) } />
        </ListSection>
      </ModalView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/courses/modals/add.jsx